export * from '@syncfusion/ej2-richtexteditor';
export { RichTextEditorComponent, RichTextEditorPlugin } from './rich-text-editor/richtexteditor.component';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-vue-richtexteditor/src/index.js
// module id = 935
// module chunks = 0